import { takeEvery } from 'redux-saga/effects';
import {PREVIEW_REQUEST_REPORT_SUCCESS} from "./types";

function* previewReport(action: any) {
    const reportBuffer = new Uint8Array(action.payload.data.data);
    const file = new Blob([reportBuffer], {type: 'application/pdf'});
    const fileURL = window.URL.createObjectURL(file);
    window.open(fileURL);
}

export default function* flightRequestReportSagas() {
    yield takeEvery(PREVIEW_REQUEST_REPORT_SUCCESS, previewReport);
}